export { withTranslation } from 'react-i18next'
export type { WithTranslation } from 'react-i18next'
